import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-[#152D4A] text-slate-400 py-12 px-6 text-center text-sm" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <p className="mb-4" data-id="element-92">
          © 2026 Clave de Paz. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-6 mb-8" data-id="element-93">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-slate-200 underline transition-colors" data-id="element-94">
            Políticas de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-slate-200 underline transition-colors" data-id="element-95">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-xs text-slate-500 max-w-xl mx-auto" data-id="element-96">
          Descargo de responsabilidad: Este material tiene fines educativos e
          informativos. No reemplaza el asesoramiento legal ni la terapia
          psicológica profesional. Si te encontrás en una situación de violencia
          o peligro físico, por favor contactá a las autoridades locales
          inmediatamente.
        </p>
      </div>

      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm" data-id="element-97">
          <div className="bg-white text-slate-900 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative text-left shadow-2xl" data-id="element-98">
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-900 bg-slate-100 rounded-full p-2 transition-colors" data-id="element-99">
              <X size={20} data-id="element-100" />
            </button>

            {activeModal === 'privacy' ? <div data-id="element-101">
                <h2 className="text-2xl font-bold mb-6 font-playfair text-slate-900" data-id="element-102">
                  Políticas de Privacidad
                </h2>
                <div className="space-y-4 text-slate-600 leading-relaxed" data-id="element-103">
                  <p data-id="element-104">
                    Tu privacidad es importante para nosotros. Es política de
                    Clave de Paz respetar tu privacidad con respecto a cualquier
                    información que podamos recopilar a través de nuestro sitio
                    web.
                  </p>
                  <p data-id="element-105">
                    Solo solicitamos información personal cuando realmente la
                    necesitamos para brindarte un servicio. La recopilamos por
                    medios justos y legales, con tu conocimiento y
                    consentimiento.
                  </p>
                  <p data-id="element-106">
                    No compartimos ninguna información de identificación
                    personal públicamente ni con terceros, excepto cuando lo
                    exija la ley.
                  </p>
                  <p data-id="element-107">
                    Nuestro sitio web puede tener enlaces a sitios externos que
                    no son operados por nosotros. Ten en cuenta que no tenemos
                    control sobre el contenido y las prácticas de estos sitios,
                    y no podemos aceptar responsabilidad u obligación por sus
                    respectivas políticas de privacidad.
                  </p>
                </div>
              </div> : <div data-id="element-108">
                <h2 className="text-2xl font-bold mb-6 font-playfair text-slate-900" data-id="element-109">
                  Términos y Condiciones
                </h2>
                <div className="space-y-4 text-slate-600 leading-relaxed" data-id="element-110">
                  <p data-id="element-111">
                    Al acceder al sitio web de Clave de Paz, aceptas estar
                    sujeto a estos términos de servicio, a todas las leyes y
                    regulaciones aplicables, y aceptas que eres responsable del
                    cumplimiento de las leyes locales aplicables.
                  </p>
                  <p data-id="element-112">
                    Los materiales contenidos en este sitio web están protegidos
                    por las leyes de derechos de autor y marcas comerciales
                    aplicables.
                  </p>
                  <p data-id="element-113">
                    Se concede permiso para descargar temporalmente una copia de
                    los materiales (información o software) en el sitio web de
                    Clave de Paz solo para visualización transitoria personal y
                    no comercial.
                  </p>
                  <p data-id="element-114">
                    Este material tiene fines educativos e informativos. No
                    reemplaza el asesoramiento legal ni la terapia psicológica
                    profesional.
                  </p>
                </div>
              </div>}
          </div>
        </div>}
    </footer>;
}